import { BankAccountDetails, BankAccountDetailsStatus, BankAccountLocation } from '@40seas/entities/bank-account';
import { EnumSchema, FromSchema, OptionalString, requireFields } from '@40seas/entities/common';
import { AddressSchema, Currency } from '@40seas/models';
import { BankAccountPayloadSchema } from 'libs/entities/bank-account/src/lib/bank-account.payload.schema';
import { z } from 'zod';

// an override to allow bank address on wire PM (as opposed to bank account) to not have zip code and address line
export const WireBankAccountDetailsSchema = z.object({
    bankName: z.string().trim().min(1, { message: 'Bank name is required' }).optional(),
    bankAccountName: z.string().optional(),
    accountNumber: z.string().trim().min(1, { message: 'Account number is required' }).optional(),
    routingNumber: OptionalString(z.string().regex(/^\d{10,12}$/, { message: 'Routing number should contain 10 to 12 digits' })),
    swiftCode: OptionalString(z.string().regex(/^\w{8}$|^\w{11}$/, { message: 'Swift code has to contain 8 or 11 letters or digits' })),
    bankAddress: requireFields(AddressSchema, ['country']).optional(),
    bankAccountPayload: z.object({ union: BankAccountPayloadSchema }).deepPartial().optional(),
    currency: EnumSchema(Currency).optional(),
    status: EnumSchema(BankAccountDetailsStatus).optional(),
    location: EnumSchema(BankAccountLocation).optional(),
});

export const WirePaymentMethodSchema = z.object({
    banksAccountDetails: z.array(WireBankAccountDetailsSchema).optional(),
    last4: z.string().optional(),
    currencyExchangeSupported: z.boolean().optional(),
});

export class WirePaymentMethod extends FromSchema(WirePaymentMethodSchema) {
    banksAccountDetails?: BankAccountDetails[];
    currencyExchangeSupported?: boolean;
    last4?: string;
}
